const TableHeaderCell = (props: any) => {

  let label = props.label ?? "";
  let align = props.align ?? "";
  let colSpan = props.colSpan ?? 1;
  let icon = props.icon ?? "";

  let className = props.className ?? "";

  return (
    <th className={className} colSpan={colSpan} style={{ textAlign: align }} scope="col">
      {label}
      {(icon) ?
        <>
          <span onClick={props.onClickOrder} className="order pointer material-symbols-outlined">
            {icon}
          </span>
        </>
        :
        <></>}
    </th>
  )
}

export default TableHeaderCell